import React, { useEffect } from "react";
import FAQList from "../components/resources/FAQList";
import ResourceDownloads from "../components/resources/ResourceDownloads";
import ContactCTA from "../components/home/ContactCTA";

const ResourcesPage = () => {
  useEffect(() => {
    document.title = "Resources | Professional Service Associates";
  }, []);

  return (
    <>
      <div className="bg-psa-green-600 py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold text-white text-center font-display">
            Resources
          </h1>
          <p className="text-psa-green-100 text-lg mt-4 max-w-3xl mx-auto text-center">
            Helpful information and resources to guide you through tax and
            business matters.
          </p>
        </div>
      </div>

      <FAQList />
      <ResourceDownloads />
      <ContactCTA />
    </>
  );
};

export default ResourcesPage;
